import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/overtime/styles.scss';export default {
  "overtime": "_overtime_19sjg_1",
  "indicator": "_indicator_19sjg_7"
};